export class Constant {
  public readonly BASE_API_URL = process.env.VUE_APP_BASE_API_URL;
  public readonly FILE_STORAGE_URL = process.env.VUE_APP_STORAGE_URL;
  public readonly MODE = process.env.NODE_ENV;
  public readonly BASE_ROUTE = process.env.VUE_APP_BASE_ROUTE;
  public readonly JUDGE_PWD = process.env.VUE_APP_JUDGE_PWD;
  public readonly EMAIL_VERIFIED_TOKEN =
    process.env.VUE_APP_EMAIL_VERIFIED_TOKEN;
  public readonly RECAPTCHA_SITE_KEY = process.env.VUE_APP_RECAPTCHA_SITE_KEY;
  public readonly loadingImage = this.BASE_ROUTE + "dist/images/";

  public readonly META_URL_EN = process.env.VUE_APP_META_URL + "eng";
  public readonly META_URL_BM = process.env.VUE_APP_META_URL + "bm";

  public readonly ARTWORK_META_EN = process.env.VUE_APP_ARTWORK_META + "eng/";
  public readonly ARTWORK_META_BM = process.env.VUE_APP_ARTWORK_META + "bm/";

  public readonly PDF_TNC_URL_EN =
    this.BASE_ROUTE + "pdf/nothing-really-mattress-T-Cs.pdf";
  public readonly PDF_TNC_URL_BM =
    this.BASE_ROUTE + "pdf/nothing-really-mattress-T-Cs.pdf";

  public readonly PDF_CONSENT_EN =
    this.BASE_ROUTE + "pdf/guardian-acknowledgement-eng.pdf";
  public readonly PDF_CONSENT_BM =
    this.BASE_ROUTE + "pdf/guardian-acknowledgement-bm.pdf";

  public readonly PDF_FAQ_URL_EN =
    this.BASE_ROUTE + "pdf/nothing-really-mattress-FAQ.pdf";
  public readonly PDF_FAQ_URL_BM =
    this.BASE_ROUTE + "pdf/nothing-really-mattress-FAQ.pdf";

  public readonly NAME_OF_MALAYSIAN_STATES = [
    "Johor",
    "Kedah",
    "Kelantan",
    "Kuala Lumpur",
    "Labuan",
    "Malacca",
    "Negeri Sembilan",
    "Pahang",
    "Penang",
    "Perak",
    "Perlis",
    "Putrajaya",
    "Sabah",
    "Sarawak",
    "Selangor",
    "Terengganu",
  ];
}

export const constant = new Constant();

import { PluginObject } from "vue/types/plugin";

export const ConstantPlugin: PluginObject<any> = {
  install: (vue, options) => {
    vue.prototype.$constant = constant;
  },
};
